// @ts-nocheck
import React, {useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {useParams, useNavigate} from 'react-router-dom'
import {useUpdatePasswordMutation, useUpdateSubAdminDetailsMutation} from '../../../../api'

const profileDetailsSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  email: Yup.string().required('Email is required'),
  phone: Yup.string().required('Contact phone is required'),
  country: Yup.string().required('Country is required'),
  subAdminType: Yup.string().required('Admin Type is required'),
  password: Yup.string().min(6).max(20),
  confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match'),
})

const SubAdminSettings: React.FC<{data: any}> = ({data}) => {
  // const {data, isLoading, error} = useGetSubAdminByIdQuery(id)
  let a = {}
  Object.assign(a, data)

  a.password = ''

  const [showModal, setShowModal] = useState(false)
  const [message, setMessage] = useState('')

  const formik = useFormik({
    initialValues: {
      name: a?.name || '',
      phone: a?.phone || '',
      email: a?.email || '',
      subAdminType: a?.subAdminType || '',
      status: a?.status || '',
      country: a?.country || '',
      // password: a.password || '',
    },
    validationSchema: profileDetailsSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      setMessage(' ')
      // if (values.password === '') {
      //   values.password = null
      // }
    },
  })

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0 cursor-pointer'
          role='button'
          data-bs-toggle='collapse'
          data-bs-target='#kt_account_profile_details'
          aria-expanded='true'
          aria-controls='kt_account_profile_details'
        >
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Update Sub Admin</h3>
          </div>
        </div>

        <div id='kt_account_profile_details' className='collapse show'>
          <form onSubmit={formik.handleSubmit} noValidate className='form'>
            <div className='card-body border-top p-9'>
              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Full Name</label>

                <div className='col-lg-8 fv-row'>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                    placeholder='First name'
                    {...formik.getFieldProps('name')}
                  />
                  {formik.touched.name && formik.errors.name && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.name}</div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span className='required'>Email</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    type='email'
                    className='form-control form-control-lg form-control-solid'
                    placeholder='Email'
                    {...formik.getFieldProps('email')}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.email}</div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span className='required'>Contact Phone</span>
                </label>

                <div className='col-lg-8 fv-row'>
                  <input
                    type='tel'
                    className='form-control form-control-lg form-control-solid'
                    placeholder='Phone number'
                    {...formik.getFieldProps('phone')}
                  />
                  {formik.touched.phone && formik.errors.phone && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.phone}</div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Country</label>

                <div className='col-lg-8 fv-row'>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                    placeholder='Country'
                    {...formik.getFieldProps('country')}
                  />
                  {formik.touched.country && formik.errors.country && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.country}</div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>Type</label>

                <div className='col-lg-8 fv-row'>
                  <input
                    type='text'
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                    placeholder='Sub admin type'
                    {...formik.getFieldProps('subAdminType')}
                  />
                  {formik.touched.subAdminType && formik.errors.subAdminType && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.subAdminType}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className='card-footer d-flex justify-content-end py-6 px-9'>
              {/* <NavLink
             to='/apps/user-management/users'
             > */}
              <button type='submit' className='btn btn-primary'>
                {!loading && 'Update Sub Admin'}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              {/* </NavLink> */}
            </div>
          </form>
        </div>
        {showModal && (
          <MessageModal
            error={error}
            showModal={showModal}
            setShowModal={setShowModal}
            message={message}
          />
        )}
      </div>
      <SignInMethod id={a._id} />
    </>
  )
}
const MessageModal = ({showModal, setShowModal, message, error}) => {
  const navigate = useNavigate()
  return (
    <>
      {' '}
      <>
        <div
          className='modal fade show d-block'
          id='kt_modal_add_user'
          role='dialog'
          tabIndex={-1}
          aria-modal='true'
        >
          <div className='modal-dialog modal-dialog-centered mw-550px'>
            <div className='modal-content'>
              <div className='modal-body scroll-y '>
                <div className='modal-header'>
                  <h5 className='modal-title fs-2'>{error ? 'Error' : 'Success'}</h5>
                </div>
                <div className='modal-body fs-3'>
                  <p>{message}</p>
                </div>
                <div className='modal-footer'>
                  <button
                    onClick={() => {
                      setShowModal(false)
                      navigate(-1)
                      navigate(-1)
                    }}
                    type='button'
                    className='btn btn-primary'
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='modal-backdrop fade show'></div>
      </>
    </>
  )
}
export default SubAdminSettings

const passwordFormValidationSchema = Yup.object().shape({
  newPassword: Yup.string('password is required')
    .required('New password is required')
    .min(6, 'new password should atleast be 6 characters long')
    .max(20),
  passwordConfirmation: Yup.string()
    .required('Confirm new password is required')
    .oneOf([Yup.ref('newPassword')], 'Passwords must match'),
})

const SignInMethod: React.FC = ({id}: string) => {
  const [resetSubAdminMutation, {loading: isLoading, error: isError}] = useMutation(
    RESET_SUBADMIN_PASSWORD_MUTATION
  )
  const [showModal, setShowModal] = useState(false)
  const [message, setMessage] = useState('')
  // const {id} = useParams()

  const formik2 = useFormik({
    initialValues: {
      newPassword: '',
      passwordConfirmation: '',
    },
    validationSchema: passwordFormValidationSchema,
    onSubmit: async (values) => {
      resetSubAdminMutation({
        variables: {
          id: id,
          newPassword: values.newPassword,
        },
        onError: (err) => {
          setMessage(err)
          setShowModal(true)
        },
        onCompleted: (result) => {
          // nameVar(values.name)

          formik2.resetForm()
          setShowModal(true)
          setMessage(result?.adminResetSubAdmin?.message)
        },
      })
    },
  })

  const showPasswordForm = true
  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0 cursor-pointer'
        role='button'
        data-bs-toggle='collapse'
        data-bs-target='#kt_account_signin_method'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Reset Password</h3>
        </div>
      </div>

      <div id='kt_account_signin_method' className='collapse show'>
        <div className='card-body border-top p-9'>
          <div className='d-flex flex-wrap align-items-center mb-10'>
            <div id='kt_signin_password' className={' ' + (showPasswordForm && 'd-none')}>
              <div className='fs-6 fw-bolder mb-1'>Password</div>
              <div className='fw-bold text-gray-600'>************</div>
            </div>

            <div
              id='kt_signin_password_edit'
              className={'flex-row-fluid ' + (!showPasswordForm && 'd-none')}
            >
              <form
                onSubmit={formik2.handleSubmit}
                id='kt_signin_change_password'
                className='form'
                noValidate
              >
                <div className='row mb-1'>
                  <div className='col-lg-4'>
                    <div className='fv-row mb-0'>
                      <label htmlFor='newpassword' className='form-label fs-6 fw-bolder mb-3'>
                        New Password
                      </label>
                      <input
                        type='password'
                        className='form-control form-control-lg form-control-solid '
                        id='newpassword'
                        {...formik2.getFieldProps('newPassword')}
                      />
                      {formik2.touched.newPassword && formik2.errors.newPassword && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik2.errors.newPassword}</div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='col-lg-4'>
                    <div className='fv-row mb-0'>
                      <label htmlFor='confirmpassword' className='form-label fs-6 fw-bolder mb-3'>
                        Confirm New Password
                      </label>
                      <input
                        type='password'
                        className='form-control form-control-lg form-control-solid '
                        id='confirmpassword'
                        {...formik2.getFieldProps('passwordConfirmation')}
                      />
                      {formik2.touched.passwordConfirmation && formik2.errors.passwordConfirmation && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik2.errors.passwordConfirmation}</div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className='form-text mb-5'>
                  {/* Password must be at least 8 character and contain symbols */}
                </div>

                <div className='d-flex'>
                  <button
                    id='kt_password_submit'
                    type='submit'
                    className='btn btn-primary me-2 px-6'
                    disabled={
                      formik2.isSubmitting ||
                      !formik2.isValid ||
                      !formik2.values.newPassword === formik2.values.passwordConfirmation
                    }
                  >
                    {!isLoading && 'Update Password'}
                    {isLoading && (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        Please wait...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                  {/* <button
                  onClick={() => {
                    setPasswordForm(false)
                  }}
                  id='kt_password_cancel'
                  type='button'
                  className='btn btn-color-gray-400 btn-active-light-primary px-6'
                >
                  Cancel
                </button> */}
                </div>
              </form>
            </div>

            <div
              id='kt_signin_password_button'
              className={'ms-auto ' + (showPasswordForm && 'd-none')}
            >
              <button
                onClick={() => {
                  setPasswordForm(true)
                }}
                className='btn btn-light btn-active-light-primary'
              >
                Reset Password
              </button>
            </div>
          </div>

          {/* <div className='notice d-flex bg-light-primary rounded border-primary border border-dashed p-6'>
          <KTSVG
            path='/media/icons/duotune/general/gen048.svg'
            className='svg-icon-2tx svg-icon-primary me-4'
          />
          <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
            <div className='mb-3 mb-md-0 fw-bold'>
              <h4 className='text-gray-800 fw-bolder'>Secure Your Account</h4>
              <div className='fs-6 text-gray-600 pe-7'>
                Two-factor authentication adds an extra layer of security to your account. To log
                in, in addition you'll need to provide a 6 digit code
              </div>
            </div>
            <a
              href='#'
              className='btn btn-primary px-6 align-self-center text-nowrap'
              data-bs-toggle='modal'
              data-bs-target='#kt_modal_two_factor_authentication'
            >
              Enable
            </a>
          </div>
        </div> */}
          {showModal && (
            <MessageModal2
              showModal={showModal}
              setShowModal={setShowModal}
              message={message}
              error={isError}
            />
          )}
        </div>
      </div>
    </div>
  )
}

const MessageModal2 = ({showModal, setShowModal, message, error}) => {
  const navigate = useNavigate()
  return (
    <>
      {' '}
      <>
        <div
          className='modal fade show d-block'
          id='kt_modal_add_user'
          role='dialog'
          tabIndex={-1}
          aria-modal='true'
        >
          <div className='modal-dialog modal-dialog-centered mw-550px'>
            <div className='modal-content'>
              <div className='modal-body scroll-y '>
                <div className='modal-header'>
                  <h5 className='modal-title fs-2'>{error ? 'Error' : 'Success'}</h5>
                </div>
                <div className='modal-body fs-3'>
                  <p>{message}</p>
                </div>
                <div className='modal-footer'>
                  {/* <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                      Close
                    </button> */}
                  <button
                    onClick={() => {
                      setShowModal(false)
                    }}
                    type='button'
                    className='btn btn-primary'
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='modal-backdrop fade show'></div>
      </>
    </>
  )
}
